import React, { useContext, useEffect, useRef, useState } from "react";

import { BoxWrapper } from "../../../style";
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper } from "../../../components/loan/style";
import Button from "../../../components/ui/Button";
import Alert from "../../../components/ui/Alert";

import { useLocation, useNavigate } from "react-router-dom";
import { getStorage, goBack, isEmpty } from "../../../Utils/common";

import PictureUpload from "../../../components/PictureUpload/PictureUpload";

import ContextDashboard from "../../../Context/ContextDashboard";
import { uploadProfilePhoto, getDashboardData } from "../../../Utils/api";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
// import { ArrowLeft } from 'lucide-react';
import { ArrowLeft, ReceiptText } from "lucide-react";

function UploadUtilitybill() {
  const [loading, setLoading] = useState(false);
  const [responce, setResponce] = useState({});
  const [image, setImage] = useState("");
  const [base64, setBase64] = useState("");
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  const { message, setMessage, logout, getProfileDaital, setps } =
    useContext(ContextDashboard);

  useEffect(() => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result;
      const data = base64.split(",");
      let img = data[data.length - 1];
      setBase64(img);
    };

    if (image) {
      if (typeof image === "string") {
        const blob = new Blob([image]);
        reader.readAsDataURL(blob);
      } else {
        reader.readAsDataURL(image);
      }
    }
  }, [image]);

  const submit = () => {
    if (image === "" && base64 === "") {
      setMessage({
        type: "error",
        msg: "Please select  utility image",
        place: "local",
      });
      return;
    } else {
      setMessage({});
    }
    let ext = "JPEG";
    if (typeof image === "object") {
      let extArr = image.name.split(".");
      ext = extArr[extArr.length - 1].toUpperCase();
    }

    const param = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      file: base64,
      ext: ext,
      password: "N/A",
      docs_id: "8",
    };

    setLoading(true);
    uploadProfilePhoto(param).then((resp) => {
      setLoading(false);
      console.log(resp?.data);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
        getProfileDaital();
        getDashboardData({ token: getStorage("token") || "", lead_id: getStorage("lead_id") || "", mobile: getStorage("mobile") || "" }).then(dashboardResp => {
          const userType = dashboardResp?.data?.Steps?.data.user_type;
          // Navigate based on user_type
          if (userType === 'REPEAT' || userType === 'UNPAID-REPEAT') {
            navigate("/my-dashboard/calculate-loan");
          } else {
            navigate("/my-dashboard/about-your-company");
          }
        })
      } else if (resp?.data?.Status === 5) {
        logout();
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });
  };
  useEffect(() => {

    const params = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      mobile: getStorage("mobile") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data?.Steps?.data || {};
        if (dashboardData) {

          setProgressBar(resp?.data?.Steps?.steps?.step_complete_percent);
        }
      } else if (resp?.data?.Status === 5) {
        logout();
      }
    });
  }, [logout]);

  useEffect(() => {
    if (!isEmpty(setps)) {
      checkStep(setps);
    }
  }, [setps]);

  const checkStep = (data) => {
    const steps = (data?.step_stage - 1);
    if (data?.step_complete_percent === 100) {
      setToggle(false);
    }
    setShowSteps(steps);
  };

  return (
    <><ProgressBar value={`${progressBar}%`}>

      <div >
      </div>
      <></>
    </ProgressBar>
      <br />



      <BoxWrapper className="w-full min-h-screen  p-3 sm:p-5 md:p-8">

        <div className="flex flex-col gap-5">

          {/* Back Button */}
          <div
            onClick={() => goBack(navigate, "/my-dashboard/upload-salaryslip")}
            className="inline-flex w-fit items-center gap-2 rounded-xl border border-gray-300 bg-white px-5 py-3 cursor-pointer transition hover:bg-gray-50"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back</span>
          </div>

          {/* Main Card */}
          <div className="w-full max-w-5xl mx-auto rounded-3xl bg-white shadow-lg p-5 sm:p-8 md:p-10">

            {/* Header */}
            <div className="text-center">

              <div className="flex justify-center mb-6">
                <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-[#EEF6FF] border border-blue-100 shadow-sm">
                  <ReceiptText className="h-8 w-8 sm:h-10 sm:w-10 text-[#2D5F7A]" />
                </div>
              </div>

              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1D3557]">
                Upload Your Utility Bill
                <span className="ml-1 text-red-500">*</span>
              </h2>

              <p className="mt-2 text-sm sm:text-base text-gray-500">
                Upload your Utility Bill to verify your details.
              </p>

            </div>

            {/* Form */}
            <FormWrapper className="mt-8">

              <Alert
                setMessage={setMessage}
                message={message}
              />

              <div className="max-w-2xl mx-auto">

                <h3 className="mb-4 text-lg sm:text-xl font-semibold text-[#1D3557]">
                  Utility Bill
                </h3>

                <PictureUpload

                  setImage={setImage}
                  image={image}
                />

              </div>

              {/* Security Card */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

                <div className="flex h-12 w-12 sm:h-14 sm:w-14 shrink-0 items-center justify-center rounded-full bg-white shadow">
                  🔒
                </div>

                <div>
                  <h4 className="text-base sm:text-lg font-semibold text-[#1D3557]">
                    Your information is safe with us
                  </h4>

                  <p className="mt-2 text-sm sm:text-base text-gray-600 leading-6">
                    We use bank-grade security to protect your documents and personal
                    information. Your uploaded utility bill is securely encrypted and
                    used only for address verification.
                  </p>
                </div>

              </div>

              {/* Continue Button */}
              <div className="mt-8">
                <Button
                  className="w-full bg-[#2D5F7A]"
                  title={state?.action ? "Update" : "Continue"}
                  onClick={submit}
                  loading={loading}
                />
              </div>

              {/* Footer */}


            </FormWrapper>

          </div>

        </div>

      </BoxWrapper>
    </>
  );
}

export default UploadUtilitybill;